import { graphql } from 'react-apollo'

import { compose, withProps } from 'recompose'

import { TierGroup, User } from 'generated/types'
import { withOptimizely } from 'utils/Optimizely'

import { DYNAMIC_COPY } from './copy'
import tierGroupQuery from './gql/tierGroup.query.gql'
import userQuery from './gql/user.query.gql'

export default compose(
  graphql<
    {},
    { user: User; tierGroupForUser: TierGroup },
    {},
    { isAuthenticated: boolean; tierGroupForUser: TierGroup }
  >(userQuery, {
    options: { fetchPolicy: 'network-only' },
    props: ({ data: { user, tierGroupForUser } }) => {
      return {
        isAuthenticated: !!user,
        tierGroupForUser,
      }
    },
  }),
  graphql(tierGroupQuery, { options: { fetchPolicy: 'network-only' } }),
  withOptimizely,
  withProps(props => {
    // Always prefer the `tierGroupForUser` data because the tier group is tied to the specific user
    // However, we need to fallback to the `tierGroup` data if the user has not created an account
    // yet (not authenticated)
    const data = props.tierGroupForUser ?? props.data?.tierGroup
    const preferredTierId = data?.preferredTierId
    const tiers = data?.tierOptions
    const { headline, subheadline } = DYNAMIC_COPY

    return {
      preferredTierId,
      tiers,
      headline,
      subheadline,
      displayedProductKeys: [],
      loading: props.data?.loading,
    }
  }),
)
